import * as Forms from '@rushplay/forms'
import * as React from 'react'

import {InputField} from './input-field'
import PropTypes from 'prop-types'

/**
 * Component that extends InputField but forces type to be password
 * @component PasswordInputField
 * @param {Object} props Components props
 * @param {string|number=} props.initialValue intial value of control
 * @param {string} props.scope scope inside dataschema of parent Form
 * @returns {ReactNode}
 */
export function PasswordInputField(props) {
  const field = Forms.useField(props.scope, {
    initialValue: props.initialValue,
  })

  return <InputField type="password" {...field} scope={props.scope} />
}

PasswordInputField.propTypes = {
  initialValue: PropTypes.string.isRequired,
  scope: PropTypes.string.isRequired,
}
